import styled from 'styled-components';
import { ATSCandidatePreferencesDataTestIds } from '../../../data-testids/ATS';

export default function Footer({
  onSubmit,
  saveText,
}: {
  onSubmit: () => void;
  saveText: string;
}): React.ReactElement {
  return (
    <Container>
      <ButtonContainer>
        <input
          id="submit"
          className={`submit btn-lrg`}
          type="submit"
          value={saveText}
          onClick={() => onSubmit()}
          disabled={false}
          data-testid={ATSCandidatePreferencesDataTestIds.SAVE_AND_NEXT_BUTTON}
        />
      </ButtonContainer>
    </Container>
  );
}

const Container = styled.div`
  padding-top: 40px;
  max-width: 1200px;
  margin: auto;
`;
const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;
